import React, { useCallback, useEffect, useState } from "react";

import { getAdminFieldModule } from "services";

import { formatCurrencyForAdmin, formatNumber, useCancelAsyncOnUnmount } from "utils";

import { AdminDescriptions, AdminSection, Col, Row } from "components";

export const FarmFieldModuleYearlyData = ({ fieldModuleId }) => {
  const [fieldModule, setFieldModule] = useState(null);
  // Deactivated for now
  // const [yearlyDataYearToUpdate, setYearlyDataYearToUpdate] = useState(null);
  // const [showDrawer, setShowDrawer] = useState(false);

  const signal = useCancelAsyncOnUnmount()();

  const loadFieldModule = useCallback(() => {
    if (!fieldModuleId) {
      return;
    }
    getAdminFieldModule({
      fieldModuleId: fieldModuleId,
      signal,
    }).then((res) => {
      setFieldModule(res);
    });
  }, [signal, fieldModuleId]);

  useEffect(() => {
    loadFieldModule();
  }, [loadFieldModule]);

  // Deactivated for now
  // const handleDrawerClose = () => {
  //   setShowDrawer(false);
  //   loadFieldModule();
  // };

  // const handleDrawerOpen = (year) => {
  //   setYearlyDataYearToUpdate(year);
  //   setShowDrawer(true);
  // };

  const formatYearlyData = (yearlyDataStatuses, yearlyData) => {
    const formattedData = {};
    yearlyDataStatuses.forEach((year) => {
      Object.entries(year).forEach(([key, value]) => (formattedData[key] = value));

      if (yearlyData) {
        Object.entries(yearlyData).forEach(([key, value]) => (formattedData[key] = value));
      }
      switch (fieldModule.module.slug) {
        case "crops": {
          let cropsInfo = {};
          Object.keys(fieldModule.cropsYearlyDataEntries).forEach((year) => {
            fieldModule.cropsYearlyDataEntries[year].forEach((item) => (cropsInfo = { ...cropsInfo, ...item }));
          });
          Object.entries(cropsInfo).forEach(([key, value]) => (formattedData[key] = value));
          break;
        }
        case "fertilizer": {
          let fertilizerInfo = {};
          Object.keys(fieldModule.fertilizerYearlyDataEntries).forEach((year) => {
            fieldModule.fertilizerYearlyDataEntries[year].forEach((item) => (fertilizerInfo = { ...fertilizerInfo, ...item }));
          });
          Object.entries(fertilizerInfo).forEach(([key, value]) => (formattedData[key] = value));
          break;
        }
        case "tillage_seeding": {
          let tillageSeedingInfo = {};
          Object.keys(fieldModule.tillageSeedingYearlyDataEntries).forEach((year) => {
            fieldModule.tillageSeedingYearlyDataEntries[year].forEach((item) => (tillageSeedingInfo = { ...tillageSeedingInfo, ...item }));
          });
          Object.entries(tillageSeedingInfo).forEach(([key, value]) => (formattedData[key] = value));
          break;
        }
        case "pesticides": {
          let pesticideInfo = {};
          Object.keys(fieldModule.pesticidesYearlyDataEntries).forEach((year) => {
            fieldModule.pesticidesYearlyDataEntries[year].forEach((item) => (pesticideInfo = { ...pesticideInfo, ...item }));
          });
          Object.entries(pesticideInfo).forEach(([key, value]) => (formattedData[key] = value));
          break;
        }
        default:
          break;
      }
    });

    Object.entries(formattedData).map(([key, value]) => {
      if (["co2", "co2Comparison"].includes(key)) {
        return (formattedData[key] = formatNumber({
          number: parseFloat(value),
          decimalPlaces: 4,
        }));
      }
      if (typeof value === "boolean") {
        return (formattedData[key] = value.toString());
      }
      if (key === "moneyAccumulate") {
        return (formattedData[key] = formatCurrencyForAdmin(parseFloat(value)));
      }
      return key;
    });
    return formattedData;
  };

  return (
    <>
      {fieldModule && (
        <>
          <AdminSection headline="Yearly data" />
          {fieldModule.yearlyDataStatuses.map((year, i) => (
            <Row key={i}>
              <Col>
                <AdminDescriptions
                  items={Object.entries(formatYearlyData([{ ...year }], fieldModule.yearlyEntries[i])).map(([key, value]) => ({
                    span: 1,
                    label: key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()),
                    children: value,
                  }))}
                  // Deactivated editing yearly data for now, only possible via verifications to not add more confusion due to calculation verions
                  // extra={
                  //   (user.role === "tier1" || user.role === "tier2" || user.role === "tier3") && (
                  //     <Button type="secondary" size="small" onClick={() => handleDrawerOpen(fieldModule.yearlyEntries[i].year)}>
                  //       Edit year data
                  //     </Button>
                  //   )
                  // }
                />
              </Col>
            </Row>
          ))}

          {/* Deactivated for now */}
          {/* <FieldModuleYearlyDataUpdate
            fieldModule={fieldModule}
            visible={showDrawer && yearlyDataYearToUpdate}
            onClose={handleDrawerClose}
            year={yearlyDataYearToUpdate}
          /> */}
        </>
      )}
    </>
  );
};
